// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__PXEGY","quoteContainer":"style_quoteContainer__YhvGP"};